module.exports = __webpack_public_path__ + "img/lf_icon.97c57c20.svg";